export default __webpack_public_path__ + "static/media/serpentine.81061871.jpg";